import { Component, OnDestroy, OnInit } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import * as moment from 'moment';
import { CsvService } from 'src/app/service/csv-service/csv.service';
import { AssistService } from 'src/app/service/assist-service/assist.service';

@Component({
  selector: 'app-assist-dashboard',
  templateUrl: './assist-dashboard.component.html',
  styleUrls: ['./assist-dashboard.component.css']
})
export class AssistDashboardComponent implements OnInit {
  user;
  timeZone;
  buckList = [];
  todayDate = [];
  search;
  driverModalObj;
  driverTrips;
  sourceType;
  constructor(
    private assistService : AssistService,
    private sharedDataService: SharedDataService,
    private csvService:CsvService
  ) { }

  ngOnInit() {
    this.getUser()
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = user.timeZone;
          this.todayDate = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];
          this.getDashboardBucks();

        }
      });
  }

  getDashboardBucks() {
    const queryParams = {
      scheduleTime : this.todayDate[0] + ',' + this.todayDate[1],
    }
    this.assistService
      .getAssistDashboard(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.buckList = data.assigns
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }

  onDateChange(event) {
    this.todayDate = [
      event[0].toISOString(),
      event[1].endOf("day").toISOString(),
    ];
      this.getDashboardBucks();
  }

  downloadCSV(source){
    this.sourceType = source
    if(this.buckList && this.todayDate){
      this.csvService.downloadMoneyForBuckReport(this.buckList,this.todayDate,this.timeZone,this.sourceType )
    }
  }

  openDriverTrips(data){
    this.driverModalObj = data;
    this.driverTrips = data.trips;
  }

  ngOnDestroy(): void {
  }

}
